import CustomToggle from "components/Drawers/Fields/CustomToggle";

const AvailableToFutureActions = ({
  available,
  setAction,
  disabled = false,
}) => {
  const handleChange = (e) => {
    const checked = e.target.checked;

    setAction((prev) => ({ ...prev, AvailableToFutureActions: checked }));
  };

  return (
    <CustomToggle
      title="Available to Future Actions"
      description="Choosing Yes makes the result of this action available to other actions."
      stateName="unique"
      value={available}
      handleChange={handleChange}
      disabled={disabled}
    />
  );
};

export default AvailableToFutureActions;
